module.exports = __webpack_public_path__ + "img/check.da702f69.svg";